<template>
    <div id="comments">
        <div class="row">
            <div class="col-md-10">
                <div class="post-interactions py-2 d-flex justify-content-between mb-5">
                    <PostLikeButton :post="post" :postLikes="postLikeList" :user="user" v-on:postLikeToggled="togglePostLike"/>
                    <PostLikeCounter :postLikes="postLikeList" v-on:likeListModalOpened="showLikeModal"/>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-10">
                <div class="comment-heading mb-4">Comments</div>
                <CommentForm ref="commentForm" v-on:commentSaved="saveComment" :pending="pending" :user="user" :post="post"/>
                <div class="comments mt-4" v-if="postComments" v-for="comment in postComments">
                    <Message :user="user" :post="post" :comment="comment" :commentLikes="getCommentLikesByCommentId(comment.id)" v-on:likeToggled="toggleCommentLike" v-on:commentReplied="saveReply"  v-on:likeListModalOpened="showLikeModal"/>
                    <div v-if="replyPendingCommentId === comment.id" class="spinner-border m-5" role="status">
                        <span class="sr-only">Loading...</span>
                    </div>
                    <div v-if="comment.children.length" class="pl-4">
                        <template v-for="child in comment.children">
                            <Message class="mt-3" :user="user" :post="post" :comment="child" :commentLikes="getCommentLikesByCommentId(child.id)" v-on:likeToggled="toggleCommentLike" v-on:commentReplied="saveReply"  v-on:likeListModalOpened="showLikeModal"/>
                            <div v-if="replyPendingCommentId === child.id" class="spinner-border m-5" role="status">
                                <span class="sr-only">Loading...</span>
                            </div>
                            <div v-if="child.children" class="pl-4">
                                <template v-for="grandchild in child.children">
                                    <Message class="mt-3" :user="user" :post="post" :replyToId="child.id" :comment="grandchild" :commentLikes="getCommentLikesByCommentId(grandchild.id)" v-on:likeToggled="toggleCommentLike" v-on:commentReplied="saveReply"  v-on:likeListModalOpened="showLikeModal"/>
                                    <div v-if="replyPendingCommentId === grandchild.id" class="spinner-border m-5" role="status">
                                        <span class="sr-only">Loading...</span>
                                    </div>
                                </template>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </div>
        <CommentLikeModal :open="commentLikeListModalOpen" :commentLikes="commentLikeList" v-on:commentLikeListModalClosed="closeLikeListModal"/>
    </div>
</template>

<script>
import commentService from '@/services/comment.service';
import LikeButton from './PostLikeButton';
import FormButton from '@/components/form/FormButton';
import FormTextarea from '@/components/form/FormTextarea';
import CommentForm from '@/components/blog/CommentForm';
import Message from '@/components/blog/Message';
import CommentLikeService from '@/services/comment-like.service';
import eventBus from '@/event-bus';
import CommentLikeButton from '@/components/blog/CommentLikeButton';
import CommentLikeModal from '@/components/blog/CommentLikeModal';
import PostLikeCounter from '@/components/blog/PostLikeCounter';
import PostLikeService from '@/services/post-like.service';

export default {
    components: {
        PostLikeCounter,
        CommentLikeModal,
        CommentLikeButton,
        FormTextarea,
        LikeButton,
        FormButton,
        CommentForm,
        Message
    },
    props: {
        post: {
            type: Object
        },
        user: {
            type: Object
        },
        reply: {
            type: Object
        },
        postLikes: {
            type: Array,
            default() {
                return [];
            }
        },
        commentLikes: {
            type: Array,
            default() {
                return [];
            }
        },
        comments: {
            type: Array,
            default() {
                return [];
            }
        },
    },
    data() {
        return {
            errors: {
                reply: {
                    error: false,
                    message: null
                }
            },
            pending: false,
            replyPendingCommentId: null,
            postComments: this.comments,
            likes: [],
            commentLikeListModalOpen: false,
            commentLikeList: [],
            postLikeList: []
        }
    },
    mounted() {
        this.likes = this.commentLikes;
        this.postLikeList = this.postLikes;
    },
    methods: {
        async toggleCommentLike(commentLike) {
            try {
                const response = await CommentLikeService.store({
                    comment_id: commentLike.comment_id,
                    post_id: this.post.id
                });

                this.likes = response.commentLikes;
            } catch (error) {
                eventBus.$emit('notification', {
                    type: 'error',
                    message: 'Something went wrong. Please refresh the page and try again.'
                });
            }
        },
        async saveComment(comment) {
            this.pending = true;

            const response = await commentService.store(
                {
                    post_id: this.post.id,
                    comment: comment.message,
                    employee_id: this.user.employee_id,
                }
            );

            this.postComments = response.comments;
            this.$refs.commentForm.form.message = '';
            this.pending = false;
        },
        async saveReply(reply) {
            this.replyPendingCommentId = reply.commentId;

            const response = await commentService.store(
                {
                    post_id: this.post.id,
                    comment: reply.message,
                    parent_id: reply.commentId,
                    employee_id: this.user.employee_id
                }
            );

            this.replyPendingCommentId = null;
            this.postComments = response.comments;
        },
        async togglePostLike(postId) {
            try {
                const response = await PostLikeService.likePost(postId);

                this.postLikeList = response.postLikes;
            } catch (error) {
                eventBus.$emit('notification', {
                    type: 'error',
                    message: 'Something went wrong. Please refresh the page and try again.'
                });
            }
        },
        getCommentLikesByCommentId(commentId) {
            return this.likes.filter(like => {
                return like.comment_id === commentId;
            })
        },
        showLikeModal(likeList) {
            this.commentLikeListModalOpen = true;
            this.commentLikeList = likeList;
        },
        closeLikeListModal() {
            this.commentLikeListModalOpen = false;
            this.commentLikeList = [];
        }
    },
    watch: {
        commentLikes(newValue) {
            this.likes = newValue;
        }
    }
}
</script>

<style scoped>
.comment-heading {
    color: #022A8A;
    font-size: 1.1rem;
    font-weight: bold;
    text-transform: uppercase;
    text-align: left;
    display: inline-block;
    align-self: flex-start;
}
</style>
